module.exports = __webpack_public_path__ + "static/media/IphonePro.75eaf497.PNG";